<template>
    <div class="scfForm">
        <div class="campusForm">
            <h1 class="scfTitleBorder">
                {{ getTranslation('camp_raum_BookDevicesTitle') }}
            </h1>
            <div class="scfIntroBorder">
                <p>
                    <div>
                        {{ getTranslation('camp_date') }}: {{ model.date.dateStr }}
                    </div>
                </p>
            </div>
            <div>
                <div>
                    <fieldset class="scfSectionBorderAsFieldSet">
                        <div class="scfSectionContent">

                            <div class="scfSingleLineTextBorder">
                                <label for="fromHour" class="scfSingleLineTextLabel">
                                    {{ getTranslation('camp_raum_TimeFrom') }}:
                                    *
                                </label>
                                <div class="scfSingleLineGeneralPanel">
                                    <input id="fromHour" type="text" v-model="fromHour" size="2" maxlength="2" class="scfSingleLineTextBox timeBox" disabled />
                                    :
                                    <input id="fromMinute" type="text" v-model="fromMinute" size="2" maxlength="2" class="scfSingleLineTextBox timeBox" disabled />
                                </div>
                            </div>

                            <div class="scfSingleLineTextBorder">
                                <label for="toHour" class="scfSingleLineTextLabel">
                                    {{ getTranslation('camp_raum_TimeUntil') }}:
                                    *
                                </label>
                                <div class="scfSingleLineGeneralPanel">
                                    <input id="toHour" type="text" v-model="toHour" size="2" maxlength="2" class="scfSingleLineTextBox timeBox" disabled />
                                    :
                                    <input id="toMinute" type="text" v-model="toMinute" size="2" maxlength="2" class="scfSingleLineTextBox timeBox" disabled />
                                </div>
                            </div>

                            <div class="scfSingleLineTextBorder">
                                <label for="title" class="scfSingleLineTextLabel">
                                    {{ getTranslation('camp_raum_TitleOfBooking') }}:
                                    *
                                </label>
                                <div class="scfSingleLineGeneralPanel">
                                    <input id="title" type="text" v-model="title" size="40" maxlength="40" class="scfSingleLineTextBox" disabled />
                                </div>
                            </div>

                            <div v-if="!saveDone && component.deviceResult && component.deviceResult.entries.length !== 0" class="scfCheckBoxListBorder">
                                <span class="scfCheckBoxListLabel">
                                    {{ getTranslation('camp_raum_Devices') }}:
                                </span>
                                <div class="scfCheckBoxListGeneralPanel">
                                    <table class="scfCheckBoxList">
                                        <tr v-for="device in component.deviceResult.entries">
                                            <td>
                                                <input :id="device.id" type="checkbox" :value="device.id" v-model="device.selected" />
                                                <label :for="device.id">{{ device.name }}</label>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>

                            <div v-if="component.deviceResult && component.deviceResult.entries.length === 0" class="scfCheckBoxListBorder">
                                <span class="scfCheckBoxListLabel">
                                    {{ getTranslation('camp_raum_NoDevicesFound') }}
                                </span>
                            </div>

                        </div>
                    </fieldset>
                </div>
            </div>

            <div v-if="saveDone" class="scfFooterBorder">
                <p>
                    <span v-for="message in saveMessagesSorted" v-bind:style="{ color: message.isError ? 'red' : 'green' }">
                        <strong>{{ message.resourceName }}</strong>: {{ message.text }}<br />
                    </span>
                </p>
            </div>

            <div v-if="!saveDone && component.deviceResult && component.deviceResult.entries.length !== 0" class="scfSubmitButtonBorder">
                <input type="submit" :disabled="component.saveButtonDisabled" :value="getTranslation('camp_edu_Save')" @click.prevent="save" class="scfSubmitButton" />
                <a href="javascript:window.history.go(-2)" class="button">{{ getTranslation('camp_Cancel') }}</a>
            </div>
            <div v-if="saveDone || (component.deviceResult && component.deviceResult.entries.length === 0)" class="scfSubmitButtonBorder">
                <input type="submit" :value="getTranslation('camp_raum_Done')" @click.prevent="doRedirect" class="scfSubmitButton" />
            </div>
        </div>
    </div>
</template>
<script>
    import RaumResResourceBooking from "../../../../_Api/RaumResResourceBooking";

    export default {
        name: 'Step2DeviceBooking',
        props: {
            model: null,
            additional: null
        },
        data() {
            return {
                "component": {
                    "deviceResult": null,
                    "saveButtonDisabled": false,
                    "saveToDoNum": null,
                    "saveMessages": []
                }
            }
        },
        created() {
            this.loadDevices();
        },
        methods: {
            loadDevices() {
                if (!this.title) {
                    dialogError("Ungültiger Aufruf der Seite", null, this.doRedirect);
                    return;
                }
                var query = {
                    "department": this.model.department,
                    "date": this.model.date.date,
                    "fromHour": this.fromHour,
                    "fromMinute": this.fromMinute,
                    "toHour": this.toHour,
                    "toMinute": this.toMinute
                };
                RaumResResourceBooking.searchDevice(query, this.searchDeviceSuccess, this.searchDeviceFailure);
            },
            doRedirect() {
                window.location = this.additional.redirectUrl;
            },
            getTranslation(key) {
                return this.model.translations[key];
            },
            searchDeviceSuccess(data) {
                if (data.successful) {
                    this.component.deviceResult = data;
                    this.styleCheckboxes();
                }
                else {
                    dialogError(data.message);
                }
            },
            searchDeviceFailure(status) {
                dialogError("Es ist ein Fehler aufgetreten: Status-Code " + status);
            },
            styleCheckboxes() {
                setTimeout(function () {
                    HSLU.forms.addIcheck();
                }, 100);
            },
            getSelectedDeviceIds() {
                var list = [];
                for (var i = 0; i < this.component.deviceResult.entries.length; i++) {
                    var device = this.component.deviceResult.entries[i];
                    if (device.selected) {
                        list.push(device.id)
                    }
                }
                return list;
            },
            save() {
                var deviceIds = this.getSelectedDeviceIds();
                if (deviceIds.length === 0) {
                    var msg = this.getTranslation('camp_raum_NoDeviceSelected');
                    dialogError(msg);
                    return;
                }
                this.component.saveButtonDisabled = true;
                this.component.saveToDoNum = deviceIds.length;
                for (var i = 0; i < deviceIds.length; i++) {
                    var deviceId = deviceIds[i];
                    this.saveDo(deviceId);
                }
            },
            saveDo(deviceId) {
                var query = {
                    "resourceId": deviceId,
                    "date": this.model.date.date,
                    "fromHour": this.fromHour,
                    "fromMinute": this.fromMinute,
                    "toHour": this.toHour,
                    "toMinute": this.toMinute,
                    "title": this.title
                };
                var thisSaveDeviceSuccess = this.saveDeviceSuccess;
                var saveDeviceSuccessWrapper = function (data) {
                    thisSaveDeviceSuccess(deviceId, data)
                };
                var thisSaveDeviceFailure = this.saveDeviceFailure;
                var saveDeviceFailureWrapper = function (status) {
                    thisSaveDeviceFailure(deviceId, status)
                };
                RaumResResourceBooking.saveBooking(query, saveDeviceSuccessWrapper, saveDeviceFailureWrapper);
            },
            saveDeviceSuccess(resourceId, data) {
                if (data.successful) {
                    var msg = this.getTranslation('camp_raum_BookingOk');
                    this.addMessage(resourceId, msg, false);
                }
                else {
                    this.addMessage(resourceId, data.message, true);
                }
            },
            saveDeviceFailure(resourceId, status) {
                this.addMessage(resourceId, "Es ist ein Fehler aufgetreten: Status-Code " + status, true);
            },
            addMessage(resourceId, text, isError) {
                var resourceName = this.getResourceName(resourceId);
                var message = {
                    resourceName: resourceName,
                    text: text,
                    isError: isError
                };
                this.component.saveMessages.push(message);
            },
            getResourceName(resourceId) {
                for (var i = 0; i < this.component.deviceResult.entries.length; i++) {
                    var device = this.component.deviceResult.entries[i];
                    if (device.id === resourceId) {
                        return device.name;
                    }
                }
                return resourceId;
            },
            formatHourMinute(value) {
                var prefix = value.length === 1 ? "0" : "";
                return prefix + value;
            },
            compareMessagesByResourceNameAsc(msgA, msgB) {
                return msgA.resourceName.localeCompare(msgB.resourceName);
            }
        },
        computed: {
            fromHour: function () {
                var value = this.$store.getters.getFromHour;
                return this.formatHourMinute(value);
            },
            fromMinute: function () {
                var value = this.$store.getters.getFromMinute;
                return this.formatHourMinute(value);
            },
            toHour: function () {
                var value = this.$store.getters.getToHour;
                return this.formatHourMinute(value);
            },
            toMinute: function () {
                var value = this.$store.getters.getToMinute;
                return this.formatHourMinute(value);
            },
            title: function () {
                return this.$store.getters.getTitle
            },
            saveDone: function () {
                if (!this.component.saveToDoNum) {
                    return false;
                }
                return this.component.saveToDoNum === this.component.saveMessages.length;
            },
            saveMessagesSorted: function () {
                return this.component.saveMessages.sort(this.compareMessagesByResourceNameAsc);
            }
        }
    }
</script>
<style scoped>
    .timeBox {
        width: auto !important;
        display: inline !important;
    }

    .scfFooterBorder {
        margin-top: 1em;
    }
</style>